export const pink = {
  50: 'var(--bfc-v2-color-pink-50, #F5F4FF)',
  100: 'var(--bfc-v2-color-pink-100, #FAE9FF)',
  200: 'var(--bfc-v2-color-pink-200, #F5D1FE)',
  300: 'var(--bfc-v2-color-pink-300, #F0ACFC)',
  400: 'var(--bfc-v2-color-pink-400, #E87AF9)',
  500: 'var(--bfc-v2-color-pink-500, #D947EF)',
  600: 'var(--bfc-v2-color-pink-600, #C027D3)',
  700: 'var(--bfc-v2-color-pink-700, #A21DAF)',
  800: 'var(--bfc-v2-color-pink-800, #861A8F)',
  900: 'var(--bfc-v2-color-pink-900, #701B75)',
  DEFAULT: 'var(--bfc-v2-color-pink-400, #E87AF9)', // 400
};
